import { render, staticRenderFns } from "./ProjectTipsExampleComponent.vue?vue&type=template&id=3131e1c6"
import script from "./ProjectTipsExampleComponent.vue?vue&type=script&lang=js"
export * from "./ProjectTipsExampleComponent.vue?vue&type=script&lang=js"
import style0 from "./ProjectTipsExampleComponent.vue?vue&type=style&index=0&id=3131e1c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports